export default __webpack_public_path__ + "static/media/customer-turquoise.022ad0b9.jpg";